import { MutationCache, QueryClient } from '@tanstack/react-query'

export const queryClient: QueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // 数据过期时间，0表示每次请求都重新获取数据
      gcTime: 0,
      retry: 1,
      refetchOnWindowFocus: false, // 获取焦点时不重新请求
    },
  },
  mutationCache: new MutationCache({
    onSuccess: async (data, _variables, _context, mutation) => {
      if (isArray(mutation.options.meta?.invalidates) && isValidResCode(data as Service.Response)) {
        const invalidates = mutation.options.meta?.invalidates
        const useQueryKeys = [invalidates]
        invalidates?.forEach(item => {
          if (isArray(item)) useQueryKeys.push(item)
        })
        return useQueryKeys.forEach(item => queryClient.invalidateQueries({ queryKey: item }))
      }
    },
  }),
})
